export class PricingWorkbenchApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createPricingV2(body) {
    return this.#http.post('/pricingWorkbench/v2', body);
  }

  async getLoan({ loanNumber }) {
    return this.#http.get(`/pricingWorkbench/loan/${loanNumber}`);
  }

  async getApplication({ applicationId }) {
    return this.#http.get(`/pricingWorkbench/application/${applicationId}`);
  }

  async getCounties({ state }) {
    return this.#http.get(`/pricingWorkbench/counties/${state}`);
  }

  async getZipLocation({ zip }) {
    return this.#http.get(`/pricingWorkbench/zip/${zip}`);
  }
}
